import React, { useContext } from "react";
import { FieldProps } from "./types";
import { IntlContext } from "context";
import getIn from "helpers/getIn";

const isDateInput = (value: unknown): value is string | number | Date =>
    typeof value === "string" || typeof value === "number" || value instanceof Date;

const DateTime: React.FC<FieldProps> = ({ source, record }) => {
    const intl = useContext(IntlContext);

    const safeRecord = record && typeof record === "object" ? (record as object) : {};
    const value = source && getIn(safeRecord, source);

    if (isDateInput(value)) {
        return <span>{intl.formatDate(value)}</span>;
    }
    return null;
};

export default DateTime;
